module.exports = __webpack_public_path__ + "img/sector.5678a6f1.jpg";